module.exports = window["wcSheerID"]["helpers"];